import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AiChatComponent } from '@shared/components/ai-chat/ai-chat.component';
import { SKIP_LOADING_HEADER } from '@shared/components/ngx-loading/interceptors/loading.interceptor';
import { NgxLoadingModule } from '@shared/components/ngx-loading/ngx-loading.module';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, NgxLoadingModule, AiChatComponent],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent {
	readonly filteredHeaders = [SKIP_LOADING_HEADER];
}
